import * as React from 'react';
import {ModuleModel} from '../../model/ModuleModel';
import {UserModel} from '../../model/UserModel';
import {getCurrentUserUUID} from '../../utils/generalUtils';
import {CustomSignaturePad} from '../reusableComponents/CustomSignaturePad';
import {Form} from '../reusableComponents/FormComponents/Form';
import {FormFooter} from '../reusableComponents/FormComponents/FormFooter';
import {InputField} from '../reusableComponents/FormComponents/InputField';
import {ImageUpload} from '../reusableComponents/ImageUpload';
import {SignatureInput} from '../reusableComponents/SignatureInput';

import { IMAGEALLOWEDEXE } from 'src/constants/generals';

export interface IAPIModules {
    Expired?: any;
    ModuleName: string;
    ModuleId: string;
    Completed: number;
    UniqueId?: string;
    TrainingDuration?: string | number;
    DateCompleted?: any;
    CompletedDate?: any;
    ParentId?: string;
}

export interface IUserFormProps {
    model: string;
    id: string;
    userImage?: string;
    singImage?: string;
    instance?: UserModel;
    loadDefaultValues?: Function;
    loggedInUser?: any;
    orgsList: any;
    moduleInstances: ModuleModel[];
    isL3User?: boolean;
    onSubmit: (values) => void;
}

export interface IUserFormState {
    isL3User: boolean;
    selectedLevel: string;
}

export class UserForm extends React.PureComponent<IUserFormProps, IUserFormState> {
    constructor(props: IUserFormProps) {
        super(props);
        this.state = {isL3User: false, selectedLevel: props.instance && props.instance.props.AccessLevel};
    }

    get profilePic() {
        return this.refs.profilePic ? this.refs.profilePic.images : '';
    }

    get signature() {
        return this.refs.userSign ? this.refs.userSign.value : '';
    }

    public refs: {
        userSign: SignatureInput
        profilePic: ImageUpload;
    };

    public getModules = () => {
        const {moduleInstances} = this.props;
        const options = [];
        moduleInstances.forEach(instance => {
            options.push({
                label: instance.props.Name,
                value: instance.props.ModuleID
            });
        });
        return options;
    }

    public getDefaultModules = (modules: IAPIModules[]) => {
        const moduleIDs = (modules || []).map((moduleData) => {
            return {label: moduleData.ModuleName, value: moduleData.ModuleId};
        });
        return moduleIDs as any;
    }

    public userLevelOptions = () => {
        let levelOptions = [];
        const loggedInUserLevel = this.props.loggedInUser.accessLevel;
        if (loggedInUserLevel === 'L1') {
            levelOptions = [{label: 'L1', value: 'L1'},
                {label: 'L2', value: 'L2'}];
        } else if (loggedInUserLevel === 'L2') {
            levelOptions = [{label: 'L2', value: 'L2'}, {label: 'L3', value: 'L3'}];
        } else {
            levelOptions = [{label: 'L3', value: 'L3'}];
        }
        return levelOptions;
    }

    getOrganizationOptions = () => {
        const orgInstances = this.props.orgsList;
        const orgList = [];
        orgInstances.map((org) => {
            orgList.push({label: org.props.OrganizationName, value: org.props.OrganizationId});
        });
        return orgList;
    }

    handleFormSubmit = (values) => {
        const {instance, loggedInUser} = this.props;
        const valuesToSend = JSON.parse(JSON.stringify(values));
        if (!valuesToSend.accessLevel) {
            return this.props.onSubmit(valuesToSend);
        }
        if (instance && loggedInUser.accessLevel !== 'L1') {
            valuesToSend['organization'] = loggedInUser.Organization;
        }
        if (valuesToSend.accessLevel === 'L1') {
            delete valuesToSend['organization'];
        }
        return this.props.onSubmit(valuesToSend);
    }

    public render() {
        const {instance, isL3User, loggedInUser} = this.props;
        let userName = 'NA';
        let isCurrentUser = false;
        if (instance) {
            userName = `${instance.props.FirstName} ${instance.props.LastName}`;
            isCurrentUser = getCurrentUserUUID() === instance.props.UniqueID;
        }
        return <Form
            loadDefaultValues={this.props.loadDefaultValues}
            model={this.props.model}
            onSubmit={this.handleFormSubmit}
            className="user-form"
        >
            {instance ?
                '' : [
                    <InputField
                        id="userID"
                        key={1}
                        hintText=""
                        label="User ID:"
                        type="number"
                        required
                        model=".userId"
                    />,
                    <InputField
                        key={2}
                        id="password"
                        hintText=""
                        label="Password:"
                        type="password"
                        required
                        model=".password"
                    />
                ]}
            <InputField
                id="firstName"
                hintText=""
                label="First Name:"
                type="text"
                required
                defaultValue={instance && instance.props.FirstName}
                model=".firstName"
            />
            <InputField
                id="userName"
                hintText=""
                label="Middle Name:"
                type="text"
                model=".middleName"
                defaultValue={instance && instance.props.MiddleName}
            />
            <InputField
                id="lastName"
                hintText=""
                label="Last Name:"
                type="text"
                required
                model=".lastName"
                defaultValue={instance && instance.props.LastName}
            />
            <InputField
                id="email"
                hintText=""
                label="Email:"
                required
                type="email"
                model=".email"
                defaultValue={instance && instance.props.Email}
            />
            <InputField
                id="jobTitle"
                hintText=""
                label="Job Title:"
                required
                type="text"
                model=".jobTitle"
                defaultValue={instance && instance.props.JobTitle}
            />
            <InputField
                id="jobDesc"
                hintText=""
                label="Job Description:"
                type="text"
                model=".jobDesc"
                defaultValue={instance && instance.props.JobDescription}
            />
            < InputField
                id="accessLevel"
                hintText=""
                color={'white'}
                label="Access Level:"
                required
                type="select"
                model=".accessLevel"
                noChips={true}
                disabled={isCurrentUser}
                onChange={value => {
                    this.setState({isL3User: value === 'L3', selectedLevel: value});
                }}
                defaultValue={instance && instance.props.AccessLevel}
                menuItems={this.userLevelOptions()}/>
            {(this.state.selectedLevel === 'L2' && loggedInUser.accessLevel === 'L1') && < InputField
                id="organization"
                hintText=""
                color={'white'}
                label="Organization:"
                required
                noChips={true}
                disabled={loggedInUser.accessLevel === 'L2'}
                type="select"
                model=".organization"
                defaultValue={instance && instance.props.Organization}
                menuItems={this.getOrganizationOptions()}/>
            }
            {
                (loggedInUser.accessLevel !== 'L1') &&
                <DetailsRow label="Organisation" value={this.props.id === 'CreateUser' ? loggedInUser.OrganizationName : (instance && instance.props.OrganizationName)}/>

            }
            {/* <FileInputButton
            id="fileInput"
            label="Onboarding Documents:"
            ref="file"
        /> */}
            {this.props.id === 'CreateUser' && this.state.selectedLevel === 'L3' ?
                <InputField
                    id="trainingModules"
                    hintText=""
                    label="Training Modules:"
                    type="select"
                    multi
                    model=".modules"
                    defaultValue={instance && this.getDefaultModules(instance.props.Modules as any)}
                    menuItems={this.getModules()}
                /> : ''}
            {isCurrentUser ?
                [<div key="1" className="text-input">
                    <div className="input-label" style={{width: '40%'}}>
                        <label>Profile Picture:</label>
                    </div>
                    <div className="input-field">
                        <ImageUpload
                            base64Image={this.props.userImage}
                            instance={this.props.instance}
                            Extensions={IMAGEALLOWEDEXE}
                            ref="profilePic"
                        />
                    </div>
                </div>,
                    <div key="2" className="text-input">
                        <div className="input-label" style={{width: '40%'}}>
                            <label>User Signature:</label>
                        </div>
                        <div className="input-field">
                            <CustomSignaturePad
                                singImage={this.props.singImage}
                                instance={this.props.instance}
                                ref="userSign"
                                userName={userName}
                            />
                        </div>
                    </div>]
                : ''}
            <FormFooter submitLabel={instance ? 'Update User' : 'Create User'}/>
        </Form>;
    }
}

const DetailsRow = ({label, value}) => {
    return <div className="text-input">
        <div className="input-label">{label}:</div>
        <div className="input-field">{value || 'NA'}</div>
    </div>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/UserForm.tsx